import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as _ from "lodash";
import { EstimateTextRowPopupParams } from "../../components/estimate-text-row-popup/estimate-text-row-popup";
import {PopupType} from "../popups/popupType";
import {PopupMode} from "../popups/popup";
import { Application } from "../application";
import { EstimateRow } from "../../services/state/estimateRow";
import { CostbookRow } from "../../services/state/costbookRow";
import { BufferItemType } from "../../services/buffer/bufferItemType";
import { CostbookRowType } from "../../services/state/costbookRowType";
import * as ko from "knockout";
import { StringUtility } from "../../services/utilities/stringUtility";

export class CreateEstimateTextRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.CreateEstimateTextRow;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        return true;
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(data: { insertAbove?: boolean, fromCostbook: boolean, bufferItemId?: number }): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let estimate = this.app.state.estimate();
        if (!estimate)
            return $.Deferred().reject().promise();

        let lastSelectedRow: EstimateRow | null = null;
        if (estimate.selectedRow().length > 0) {
            lastSelectedRow = estimate.baseRow();
        }

        if (data.fromCostbook) {
            let buffer = this.app.state.buffer();

            let bufferItem = _.first(buffer);

            if (!bufferItem)
                return $.Deferred().reject().promise();

            if (bufferItem.type != BufferItemType.costRow)
                return $.Deferred().reject().promise();

            let costbookRow = <CostbookRow>bufferItem.data;

            if (!costbookRow)
                return $.Deferred().reject().promise();

            let text = undefined;

            switch (costbookRow.type) {
                case CostbookRowType.section:
                    text = costbookRow.attributes.sectionTitle;
                    let sectionDescriptions = costbookRow.attributes.sectionDescriptions;

                    if (sectionDescriptions) {
                        for (let i = 0; i < sectionDescriptions.length; i++) {
                            text = text + "\n" + sectionDescriptions[i];
                        }
                    }
                    break;
                case CostbookRowType.text:
                    text = StringUtility.removeTags(costbookRow.attributes.text);

                    if (!text || text.trim() == '') {
                        console.log('empty rows should not be pasted. skipping.')
                        return $.Deferred().resolve().promise();
                    }
                    break;
                default:
                    return $.Deferred().reject().promise();
            }

            return this.app.apiManager.estimateRows.saveTextRow({
                estimateId: this.app.state.estimate()!.id(),
                id: undefined,
                baseRowId: bufferItem.pasteToTheEnd ? undefined : (estimate.baseRow() ? estimate.baseRow()!.id : undefined),
                text: text,
            }).then((data) => {
                this.app.state.canUndo(data!.history.canUndo);
                this.app.state.canRedo(data!.history.canRedo);

                estimate!.pendingSelectedRowId(data!.id);

                this.app.state.estimate()!.timestamp(new Date());
                console.log('text row saved');
                return $.Deferred().resolve(data).promise();
            })

        }
        else {

            let params = <EstimateTextRowPopupParams>{
                popupMode: PopupMode.New,
                insertAbove: data.insertAbove,
            };

            let dfd = $.Deferred();
            
            let selectedRows = this.app.state.estimate()!.selectedRow();

            this.app.apiManager.estimateRows.saveTextRow({
                estimateId: this.app.state.estimate()!.id(),
                id: undefined,
                baseRowId: data.insertAbove ? -1 : selectedRows.length > 0 ? selectedRows[0].id : estimate.baseRow() ? estimate.baseRow()!.id : undefined,
                text: ""
            }).then((data) => {
                //read created row and focus on it
                this.app.apiManager.estimateRows.getRow(this.app.state.estimate()!.id(), data!.id).then((rowdata) => {
                    console.log('new text row created', rowdata!.data[0]);

                    this.app.state.canUndo(data!.history.canUndo);
                    this.app.state.canRedo(data!.history.canRedo);

                    this.app.state.estimate()!.timestamp(new Date());

                    this.app.state.estimate()!.focusedRowOrder(rowdata!.data[0].order);
                    this.app.state.estimate()!.clickedTextRow(rowdata!.data[0]);
                });


            });

            return dfd.promise();
        }
    }


    name = "Create New Text Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/createEstimateTextRowCommand.ts